import moment from "moment";
// import { logoutUser } from "../store/actions/login.actions";
import agent from "../services/agent";
import { USER_LOGOUT } from "../store/constants/login.constants";

export const setTokenDetails = (authData: any) => {
  const { accessToken, tokenType, expiresInSec } = authData;
  const expires = moment().unix() + expiresInSec;
  sessionStorage.setItem('accessToken', accessToken);
  sessionStorage.setItem('expiresInSec', expires);
  sessionStorage.setItem('token_type', tokenType);
};

export const getToken = (dispatch?: Function): any => {
  // const access_token = localStorage.getItem("accessToken"); //cdc email claim not available in accessToken
  const access_token =  sessionStorage.getItem("accessToken");
  const expires_in = sessionStorage.getItem("expiresInSec");
  // sessionStorage.getItem("expires_in");
  // const refresh_token = localStorage.getItem("refresh_token");

  return new Promise((resolve) => {
    // check the difference between now and expired time for current token
    const diff = moment.unix(Number(expires_in)).diff(moment(), "minutes");

    if (access_token && diff > 5) {
      resolve(access_token);
    } else {
      agent.Auth.getRefreshToken(access_token)
        .then((authData) => {
          setTokenDetails(authData);
          resolve(sessionStorage.getItem("accessToken")); // resolve - id_token
        })
        .catch((err) => {
          resolve(err);
          dispatch && dispatch({ type: USER_LOGOUT });
        });
      // console.log("getToken ", diff);
      // dispatch && dispatch(logoutUser("TokenExpired"));
      // resolve(access_token);
    }
  });
};
